export class LinkUtils {
  static getAdminHref() {
    if (
      process.env.NEXT_PUBLIC_WEBSITE === "monkeystime.co.uk" ||
      process.env.NEXT_PUBLIC_WEBSITE === "monkeystime.eu"
    ) {
      return "https://admin.monkeystime.co.uk"
    }
    const domain = process.env.NEXT_PUBLIC_DOMAIN || process.env.REACT_APP_DOMAIN
    return `https://admin.${domain}`
  }
}
